export default [
  { titleKey: 'meta.alternate_links.blog', href: 'https://rss.com/blog/feed/' },
  { titleKey: 'meta.alternate_links.press_releases', href: 'https://rss.com/blog/category/press-releases/feed/' },
  { titleKey: 'meta.alternate_links.changelog', href: 'https://changelog.rss.com/rss' }
]
